import { StyleSheet } from "aphrodite";
import theme from "../../common/theme/mellon";

export default StyleSheet.create({
    container: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
    },
    mainContainer: {
        flex: 1,
        display: "flex",
        paddingTop: "40px",
    },
    flexContainer: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        padding: "20px",
    },
    confirmDiv: {
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: "30px",
        marginBottom: "15px",
    },
    centerContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
    row: {
        display: "flex",
        width: "100%",
        flexDirection: "row",
        justifyContent: "center",
    },
    halfColumn: {
        flex: 1,
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
    space: {
        marginRight: "15px",
    },
    notesDiv: {
        maxWidth: "564px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
    },
    fieldDiv: {
        width: "100%",
        background: theme.colors.white,
        border: "1px solid " + theme.palette.secondary.dark,
        padding: "5px 15px",
        borderRadius: "5px",
    },
    mobileDiv: {
        marginTop: "15px",
        gap: "15px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        maxWidth: "320px",
    },
    button: {
        width: "100%",
        maxWidth: "400px",
        height: 60,
        margin: "30px 0px",
        alignSelf: "flex-start",
        "@media (max-width: 799px)": {
            width: "100%",
            maxWidth: "400px",
            alignSelf: "center",
        },
    },
    captchaContainer: {
        width: "100%",
        display: "flex",
        paddingTop: "15px",
        justifyContent: "flex-start",
        "@media (max-width: 799px)": {
            justifyContent: "center"
        }
    },
    extraFieldsContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        paddingTop: "15px",
        justifyContent: "flex-start",
        "@media (max-width: 799px)": {
            justifyContent: "center"
        }
    },
    phoneNumberContainer: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "row",
        // gap: "10px",
        width: "100%",

        // paddingTop: "15px",
        "@media (max-width: 799px)": {
            justifyContent: "center"
        }
    },
    phoneNumberInnerContainer: {
        display: "flex",
        flexWrap: "nowrap",
        maxWidth: 400,
        width: '100%'
    },
    selectForm: {
        width: 75,
        justifyContent: "flex-start",
        // paddingTop: 12,
        // paddingBottom: 12,
    },
    textareaContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        width: "100%",
        maxWidth: "400px",
        alignSelf: "flex-start",
        contain: "layout style paint",
    },
    textareaLabelContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "8px",
        marginBottom: "-17px",
    },
    infoIconButton: {
        padding: "4px !important",
        color: theme.palette.primary.main,
    },
    textareaField: {
        width: "100%",
        padding: "5px 0px",
        fontFamily: "inherit",
        fontSize: "1rem",
        border: "none",
        borderBottom: "1px solid " + theme.palette.primary.dark,
        boxSizing: "border-box",
        outline: "none",
        marginTop: "12px",
        resize: "vertical",
        lineHeight: "1.3",
        minHeight: "80px",
        contain: "layout style",
        "::placeholder": {
            color: "rgba(0, 0, 0, 0.42)",
            opacity: 1,
        },
        ":focus-visible": {
            outline: "none",
            borderBottom: `2px solid ${theme.palette.primary.main}`,
        },
    },
    textareaError: {
        borderBottom: "1px solid " + theme.palette.error.main + " !important",
    },
    error: {
        color: theme.palette.error.main,
    },
    errorField: {
        marginTop: "5px",
    },
    mobileInfoText: {
        display: "block",
        marginTop: "10px",
        marginBottom: "8px",
        color: theme.palette.primary.main,
        fontStyle: "italic",
        border: "1px solid " + theme.palette.primary.main,
        backgroundColor: theme.palette.secondary.light,
        padding: "10px",
        borderRadius: "5px",
    }
});
